function Step2FabOurTeamContent({
 templateState,
 setTemplateField,

 card1ImageFile,
 setCard1ImageFile,
 existingCard1ImageUrl,
 removeCard1Image,
 setRemoveCard1Image,

 card2ImageFile,
 setCard2ImageFile,
 existingCard2ImageUrl,
 removeCard2Image,
 setRemoveCard2Image,

 card3ImageFile,
 setCard3ImageFile,
 existingCard3ImageUrl,
 removeCard3Image,
 setRemoveCard3Image,
}) {
 return (
  <div className="card">
   <h2>FAB Our Team Content</h2>

   <label className="field">
    <span>Page Title</span>

    <input
     type="text"
     value={templateState.title || ""}
     onChange={(e) =>
      setTemplateField("title", e.target.value)
     }
     placeholder="BECOME PART OF FAB"
    />
   </label>

   <hr />

   <h3>Card 1</h3>

   <div className="field">
    <span>Card 1 Image</span>

    {existingCard1ImageUrl &&
     !card1ImageFile &&
     !removeCard1Image ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current card 1 image uploaded
      </span>

      <a
       href={existingCard1ImageUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveCard1Image(true);
        setCard1ImageFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeCard1Image ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Card 1 image will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveCard1Image(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="fab-our-team-card-1-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setCard1ImageFile(file);

       if (file) {
        setRemoveCard1Image(false);
       }
      }}
     />

     <label
      htmlFor="fab-our-team-card-1-upload"
      className="file-btn"
     >
      Choose File
     </label>

     <div className="file-name">
      {card1ImageFile?.name || "No file chosen"}
     </div>
    </div>
   </div>

   <label className="field">
    <span>Card 1 Title</span>

    <input
     type="text"
     value={templateState.card1_title || ""}
     onChange={(e) =>
      setTemplateField("card1_title", e.target.value)
     }
     placeholder="EXPANSION PARTNER"
    />
   </label>

   <label className="field">
    <span>Card 1 Description</span>

    <textarea
     rows={5}
     className="textarea"
     value={templateState.card1_description || ""}
     onChange={(e) =>
      setTemplateField(
       "card1_description",
       e.target.value
      )
     }
     placeholder="League Expansion Partner plays a pivotal role in building brand awareness and spearheading the expansion into untapped markets."
    />
   </label>

   <div className="row-2">
    <label className="field">
     <span>Card 1 Button Label</span>

     <input
      type="text"
      value={templateState.card1_button_label || ""}
      onChange={(e) =>
       setTemplateField(
        "card1_button_label",
        e.target.value
       )
      }
      placeholder="Learn More"
     />
    </label>

    <label className="field">
     <span>Card 1 Button Link</span>

     <input
      type="text"
      value={templateState.card1_button_link || ""}
      onChange={(e) =>
       setTemplateField(
        "card1_button_link",
        e.target.value
       )
      }
      placeholder="/contact"
     />
    </label>
   </div>

   <hr />

   <h3>Card 2</h3>

   <div className="field">
    <span>Card 2 Image</span>

    {existingCard2ImageUrl &&
     !card2ImageFile &&
     !removeCard2Image ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current card 2 image uploaded
      </span>

      <a
       href={existingCard2ImageUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveCard2Image(true);
        setCard2ImageFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeCard2Image ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Card 2 image will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveCard2Image(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="fab-our-team-card-2-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setCard2ImageFile(file);

       if (file) {
        setRemoveCard2Image(false);
       }
      }}
     />

     <label
      htmlFor="fab-our-team-card-2-upload"
      className="file-btn"
     >
      Choose File
     </label>

     <div className="file-name">
      {card2ImageFile?.name || "No file chosen"}
     </div>
    </div>
   </div>

   <label className="field">
    <span>Card 2 Title</span>

    <input
     type="text"
     value={templateState.card2_title || ""}
     onChange={(e) =>
      setTemplateField("card2_title", e.target.value)
     }
     placeholder="BECOME AN OFFICIAL"
    />
   </label>

   <label className="field">
    <span>Card 2 Description</span>

    <textarea
     rows={5}
     className="textarea"
     value={templateState.card2_description || ""}
     onChange={(e) =>
      setTemplateField(
       "card2_description",
       e.target.value
      )
     }
     placeholder="We provide comprehensive training and support to all our referees, equipping you with the knowledge and skills needed to excel on the court."
    />
   </label>

   <div className="row-2">
    <label className="field">
     <span>Card 2 Button Label</span>

     <input
      type="text"
      value={templateState.card2_button_label || ""}
      onChange={(e) =>
       setTemplateField(
        "card2_button_label",
        e.target.value
       )
      }
      placeholder="Learn More"
     />
    </label>

    <label className="field">
     <span>Card 2 Button Link</span>

     <input
      type="text"
      value={templateState.card2_button_link || ""}
      onChange={(e) =>
       setTemplateField(
        "card2_button_link",
        e.target.value
       )
      }
      placeholder="/contact"
     />
    </label>
   </div>

   <hr />

   <h3>Card 3</h3>

   <div className="field">
    <span>Card 3 Image</span>

    {existingCard3ImageUrl &&
     !card3ImageFile &&
     !removeCard3Image ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current card 3 image uploaded
      </span>

      <a
       href={existingCard3ImageUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveCard3Image(true);
        setCard3ImageFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeCard3Image ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Card 3 image will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveCard3Image(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="fab-our-team-card-3-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setCard3ImageFile(file);

       if (file) {
        setRemoveCard3Image(false);
       }
      }}
     />

     <label
      htmlFor="fab-our-team-card-3-upload"
      className="file-btn"
     >
      Choose File
     </label>

     <div className="file-name">
      {card3ImageFile?.name || "No file chosen"}
     </div>
    </div>
   </div>

   <label className="field">
    <span>Card 3 Title</span>

    <input
     type="text"
     value={templateState.card3_title || ""}
     onChange={(e) =>
      setTemplateField("card3_title", e.target.value)
     }
     placeholder="BECOME A SCOREKEEPER"
    />
   </label>

   <label className="field">
    <span>Card 3 Description</span>

    <textarea
     rows={5}
     className="textarea"
     value={templateState.card3_description || ""}
     onChange={(e) =>
      setTemplateField(
       "card3_description",
       e.target.value
      )
     }
     placeholder="As a scorekeeper, you'll play a vital role in ensuring smooth and accurate game operations."
    />
   </label>

   <div className="row-2">
    <label className="field">
     <span>Card 3 Button Label</span>

     <input
      type="text"
      value={templateState.card3_button_label || ""}
      onChange={(e) =>
       setTemplateField(
        "card3_button_label",
        e.target.value
       )
      }
      placeholder="Learn More"
     />
    </label>

    <label className="field">
     <span>Card 3 Button Link</span>

     <input
      type="text"
      value={templateState.card3_button_link || ""}
      onChange={(e) =>
       setTemplateField(
        "card3_button_link",
        e.target.value
       )
      }
      placeholder="/contact"
     />
    </label>
   </div>
  </div>
 );
}

export default Step2FabOurTeamContent;